import api from "../api";

export const generatePassword = async () => {
    const { data } = await api.get('manager/generate_password/');
    return data
}

export const createUser = async (params: any) => {
    const { data } = await api.post('manager/profile/', params);
    return data
}

export const changeUserState = async (id: any, status?: boolean) => {
    const { data } = await api.post(`/manager/partner/${id}`, { status: status });
    return data
}

export const removeUser = async (id: any) => {
    const { data } = await api.delete(`/manager/profile/${id}`, { data: { remove: true }});
    return data
}

export const getUsers = async (query?: string) => {
    if (query) {
        const { data } = await api.get(`manager/profile?${query}`);
        return data
    } else {
        const { data } = await api.get('manager/profile/');
        return data
    }
}

export const getUsersSubscribers = async (query?: string) => {
    if (query) {
        const { data } = await api.get(`manager/profile?type_user=1&${query}`);
        return data
    } else {
        const { data } = await api.get('manager/profile?type_user=1');
        return data
    }
}

export const getUsersPartners = async (query?: string) => {
    if (query) {
        const { data } = await api.get(`manager/profile?type_user=2&${query}`);
        return data
    } else {
        const { data } = await api.get('manager/profile?type_user=2');
        return data
    }
}

export const getUsersGuests = async (query?: string) => {
    if (query) {
        const { data } = await api.get(`manager/profile?type_user=3&${query}`);
        return data
    } else {
        const { data } = await api.get('manager/profile?type_user=3');
        return data
    }
}

export const getLeads = async (query?: string) => {
    if (query) {
        const { data } = await api.get(`manager/leads/?${query}`);
        return data
    } else {
        const { data } = await api.get('manager/leads/');
        return data
    }
}